import axios from 'axios'
import StorageService from '../app/service/storageService'
import { messageError } from '../components/toastr';
import authenticationProvider from '../main/authenticationProvider';
import AuthContext from '../main/authenticationProvider';

export const httpClient = axios.create({
    //  baseURL: 'https://rotatrack.everlink.com.br/api/'
    //  baseURL: 'https://cors-anywhere.herokuapp.com/https://rotatrack.everlink.com.br/api/'
    //    baseURL: 'https://rotatrackteste.everlink.com.br/api/'
    //  baseURL: 'https://rotatrackteste.everlink.com.br/api/'
    //    baseURL: 'http://localhost:8082/api/'
});

httpClient.interceptors.response.use((config) => {
    return config;
}, (err) => {
    if (err.response && err.response.status === 401) {
        messageError('ERRO! Acesso expirado. Favor efetuar novo login.');

        setTimeout(() => {
            const auth = new AuthContext();
            auth.endSession();
            window.location.href = '/login';
        }, 2000);
    }
    return Promise.reject(err);
});

class ApiService {

    constructor(apiurl) {
        // this.apiurl = 'https://rotatrack.everlink.com.br/api';
        this.apiurl = 'https://rotatrackteste.everlink.com.br/api';
        // this.apiurl = 'http://localhost:8082';
        // this.apiurl = apiurl;
    }
    post(url, objeto, needAuthentication) {
        const requestUrl = `${this.apiurl}${url}`
        if (needAuthentication && needAuthentication === 1) {
            const token = StorageService.getItem('everlink_user');
            const authType = StorageService.getItem('everlink_type') === 'mgmt' ? 'EverlinkRtMgmt' : 'EverlinkRt';

            return httpClient.post(requestUrl, objeto, { headers: { "Authorization": `${authType} ${token}` } });
        } else {
            return httpClient.post(requestUrl, objeto);
        }
    }

    put(url, objeto) {
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.put(requestUrl, objeto);
    }

    delete(url) {
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.delete(requestUrl)
    }

    get(url, objeto) {
        const token = StorageService.getItem('everlink_user');
        const authType = StorageService.getItem('everlink_type') === 'mgmt' ? 'EverlinkRtMgmt' : 'EverlinkRt';
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.get(requestUrl, {
            headers: { "Authorization": `${authType} ${token}` },
            params: objeto
        })
    }
}


export default ApiService;